import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="page contact-page">
      <div className="container-narrow">
        <header className="page-header">
          <h1>Contact Us</h1>
          <p className="subtitle">
            We welcome inquiries about our research, participation
            opportunities, and collaborations.
          </p>
          <div className="accent-bar"></div>
        </header>

        <div className="contact-grid">
          <a href="mailto:kidney.reach@ucalgary.ca" className="contact-card">
            <div className="contact-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <h3>Email</h3>
            <p className="contact-value">kidney.reach@ucalgary.ca</p>
          </a>
                    <a href="mailto:reach@ucalgary.ca" className="contact-card">
            <div className="contact-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <h3>Email</h3>
            <p className="contact-value">reach@ucalgary.ca</p>
          </a>

          <a href="tel:+14032109610" className="contact-card">
            <div className="contact-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </div>
            <h3>Phone</h3>
            <p className="contact-value">403-210-9610</p>
          </a>

          <div className="contact-card contact-card-address">
            <div className="contact-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </div>
            <h3>Location</h3>
            <p className="contact-value">
              Cal Wenzel Precision Health Building<br />
              Foothills Medical Campus<br />
              Calgary, Alberta
            </p>
          </div>
        </div>

        <section className="contact-note">
          <h2>Get in Touch</h2>
          <p>
            Whether you're interested in participating in our research,
            exploring a collaboration, or learning more about our work, we'd
            love to hear from you. Please email us at{' '}
            <a href="mailto:kidney.reach@ucalgary.ca">
              kidney.reach@ucalgary.ca
            </a>{' '}
            and a member of our team will get back to you.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Contact;
